import { string } from "yup"

const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

export const emailSchema = string().matches(emailRegex, {
  message: "yup.common.string.email",
  name: "email",
  excludeEmptyString: true,
})
